import {
  mapActions, mapState, mapGetters,
} from 'vuex';
import * as rootTypes from '@/store/types';
import * as campaignTypes from '@/modules/campaigns/store/types';

export default {
  computed: {
    ...mapState('campaigns', [
      'currencies',
    ]),
    ...mapGetters({
      currencyMap: rootTypes.GET_CURRENCY_MAP,
    }),
  },
  methods: {
    ...mapActions('campaigns', [
      campaignTypes.FETCH_CURRENCIES,
    ]),
    getFormattedMoneyAmountByOrder(budget, order, htmlFormat) {
      if (!order.currencyId || !this.currencies) return '';
      const chosenCurrency = this.currencies
        .find((currency) => currency.id === order.currencyId);
      if (!chosenCurrency) return '';
      const currencySymbol = this.currencyMap[chosenCurrency.code];
      return this.getFormattedMoneyAmount(budget, currencySymbol, htmlFormat);
    },
    getFormattedMoneyAmount(amount, currency, htmlFormat) {
      if (!amount) {
        return null;
      }
      const currencies = {
        left: [],
        right: [],
      };
      this.currencies.forEach((item) => {
        if (item.symbolPosition === 'PREFIX') currencies.left.push(item.symbolString);
        else currencies.right.push(item.symbolString);
      });

      if (htmlFormat) {
        return (currencies.left.includes(currency)) ? `<small>${currency}</small>${amount}` : `<small>${amount}</small>${currency}`;
      }

      return (currencies.left.includes(currency)) ? `${currency}${amount}` : `${amount}${currency}`;
    },
  },
  created() {
    if (this.currencies.length === 0) this.FETCH_CURRENCIES();
  },
};
